export const CookiesEnum = {
  android: 'Android_APP',
  ios: 'IOS_APP',
  web: 'NotAPP'
}
export const AllowedAppCookies = [
  CookiesEnum.android,
  CookiesEnum.ios
]

export const COOKIE_NAME = 'drushim_platform';
